<template>
  <div class="tab1 module_item" :class="{'isMobileIndustry':isMobile}">
    <div class="search">
      <el-select
        v-model="industryData.location"
        placeholder="location"
        class="module_search_select"
        @change="emitSearch"
      >
        <el-option v-for="item in Locations" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <!--  -->
      <el-select
        v-model="industryData.choseName"
        placeholder="Class"
        class="module_search_select"
        @change="emitSearch"
      >
        <el-option v-for="item in industyCls" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <!--  -->
      <el-select
        v-model="industryData.time"
        placeholder="Period"
        class="module_search_select"
        @change="emitSearch"
      >
        <el-option v-for="item in allPeriod" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <div class="resetBtn">
        <i class="el-icon-refresh" @click="resetCondiction" title="reset"></i>
        <!-- <el-button type="text" @click="resetCondiction">Reset</el-button> -->
      </div>
    </div>

    <div class="total-top">
      Total
      <span class="totalCls">{{total}}</span> records
    </div>

    <div class="list_resullt" v-if="lists.length">
      <el-checkbox-group v-model="checkList" @change="checkListChange" v-if="!isMobile">
        <div
          class="result_item"
          v-for="(item,index) of lists"
          :key="index"
          :class="{activeModuleCls:activeList.includes(item.id)}"
        >
          <!-- 此处如果 checkbox label = "item"时,checkList存入的时每个item的数组 -->
          <!-- 当分页时,选取某一项,然后跳页,当返回此页时无法回显, checkList中存入的对象  对象的引用不同,所以无法回显,即使值相同 -->
          <!-- 如果只是存list只是存id,然后在js逻辑中去根据id筛选得到item,为了在其他地方使用  -->
          <!-- 同样的 分页后,原来的数据就会被更新,所以原来的id就无法找到对应的item -->
          <!-- JSONStringfy 转换为字符串 即 list中是每一个item的json, string类型,在回显时,判断相等即回显 -->
          <el-checkbox :label="JSON.stringify(item)" :disabled="!!item.disabled">
            <div class="item_title">
              <span class="title">{{item.name}}</span>
              <slot name="tag" :item="item"></slot>
            </div>

            <div class="detail">
              <p v-for="(list,j) of detailLists" :key="j" class="detail_item">
                <span class="tag_label">{{list.label}}:&nbsp &nbsp</span>
                <span class="tab_value">{{item[list.key]}}</span>
              </p>
            </div>
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <!--  -->
      <div v-else>
        <div
          class="result_item"
          v-for="(item,index) of lists"
          :key="index"
          @click.stop="searchData(item)"
        >
          <div class="item_title">
            <span class="title">{{item.name}}</span>
            <slot name="tag" :item="item"></slot>
          </div>

          <div class="detail">
            <p v-for="(list,j) of detailLists" :key="j" class="detail_item">
              <span class="tag_label">{{list.label}}:&nbsp &nbsp</span>
              <span class="tab_value">{{item[list.key]}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="list_resullt" v-else>
      <div class="noData no_data_container" @click="changRightStatus">
        <span class="img no_data_img"></span>
        <p>Sorry, No data was found</p>
      </div>
    </div>

    <div class="page_footer clearfix">
      <el-pagination
        :total="total"
        background
        layout="prev, pager, next"
        :current-page="industryData.page"
        :pager-count="5"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getNation } from "common/js/http/v2Api";
import { Locations, industyCls, allPeriod } from "conf/industrySelect";
import { mapState, mapMutations } from "vuex";

const detailLists = [
  {
    label: "Country/Region",
    key: "location" //后台字段
  },
  {
    label: "Frequency",
    key: "time" //后台字段
  },
  {
    label: "Unit",
    key: "unit" //后台字段
  },
  {
    label: "Data-Source",
    key: "resource" //后台字段
  }
];

export default {
  props: ["lists", "total"],
  data() {
    return {
      Locations,
      industyCls,
      allPeriod,
      detailLists, //每个模块的字段不同
      list: [],
      checkList: [],

      industryData: {
        location: Locations[0],
        choseName: industyCls[0],
        time: allPeriod[0],
        page: 1,
        size: 10
      },
      checkListLen: 0,
      activeList: []
    };
  },

  created() {},

  mounted() {
    this.emitSearch();
  },

  methods: {
    emitSearch() {
      let data = this.$lodash.cloneDeep(this.industryData);
      data.location = data.location.includes("All") ? "All" : data.location;
      data.choseName = data.choseName.includes("All") ? "All" : data.choseName;
      data.time = data.time.includes("All") ? "All" : data.time;

      this.$emit("search", "industry", data);

      this.checkList = [];
      this.setListChecked(this.checkList);
    },

    searchData(item) {
      // this.$router.push({
      //   path: "/data/SearchModule/Industry"
      // });
      this.$emit("changRightStatus", "Industry", item.id);
    },

    handleCurrentChange(val) {
      this.industryData.page = val;
      this.emitSearch();
    },

    checkListChange() {
      this.activeList = this.checkList.map(item => JSON.parse(item).id);
      if (this.checkList.length > 1) {
        const typePre = JSON.parse(this.checkList[this.checkList.length - 2])
          .time;
        const typeCurrent = JSON.parse(
          this.checkList[this.checkList.length - 1]
        ).time;
        if (typeCurrent != typePre) {
          this.checkList.pop();
          this.$message({
            message: "Different Period Can not Compare !",
            type: "warning"
          });
        }
      }
      //没有数据权限
      if (!this.allKey.INDUSTRY_DETAIL) {
        this.$message({
          message: "Sorry, there are no permissions !",
          type: "warning"
        });
      }

      //关闭主页显示
      this.changeIndexShow(false);
      this.setListChecked(this.checkList);
    },

    changRightStatus() {
      this.$emit("changRightStatus", "Industry");
    },

    resetCondiction() {
      this.industryData = {
        location: Locations[0],
        choseName: industyCls[0],
        time: allPeriod[0],
        page: 1,
        size: 10
      };
      this.emitSearch();
    },

    ...mapMutations(["setListChecked","changeIndexShow"])
  },

  computed: {
    ...mapState({
      ListChecked(state) {
        return state.IndustyChecked.ListChecked;
      },
      isMobile(state) {
        return state.MobileStatus.isMobile;
      },
      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  },

  watch: {
    $attrs(newValue) {
      console.log("TCL: $attrs -> newValue", newValue);
    },

    ListChecked(newValue) {
      this.checkList = newValue;
      if (!newValue.length) {
        this.activeList = [];
      }
    }
  }
};
</script>

<style scoped>
.list_resullt {
  margin-top: 10px;
  height: calc(100% - 240px);
  overflow-y: auto;
  padding: 0px 10px 0px 0px;
}

.page_footer >>> .el-pagination {
  float: right;
}

.total_page {
  float: left;
  height: 32px;
  line-height: 32px;
}

.page_footer {
  border-top: 1px solid #dee2e6;
  padding-top: 16px;
}

.tag_label {
  display: inline-block;
  width: 130px;
}

.tab_value {
  display: inline-block;
  width: calc(100% - 130px);
  vertical-align: top;
}
.list_resullt >>> .el-checkbox {
  width: 100% !important;
}
.list_resullt >>> .el-checkbox .el-checkbox__input {
  position: absolute !important;
  right: 20px !important;
  top: 25px !important;
}
.isMobileIndustry .list_resullt >>> .el-checkbox__input {
  display: none !important;
}
</style>